/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import image and SVG starts */
import { TickGreen } from "../../../../../setup/constants/images";
/* Import image and SVG ends */

/* Import local pages and component starts */
import TextButton from "../../../../ui/button/TextButton/TextButton";
/* Import local pages and component ends */

/* Component starts */
const UnderReview = (props) => {
  /* Props destructuring starts */
  const { onCancelRenewal } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div className="container_sm application-under-review-status">
      <div className="custom-card">
        <div className="status-icon-wrapper text-center">
          <img className="status-icon" src={TickGreen} alt="" />
        </div>
        <h1 className="font_xxl text-center font_blue fw_7">Thank You</h1>
        <p className="font_m fw_5 text-center description">
          Your Application Submitted Successfully !
        </p>
        <p className="font_m fw_5 text-center font_yellow">
          Application Pending Review!
        </p>
      </div>

      <div className="cancel_renewal text-center">
        <TextButton
          onClick={onCancelRenewal}
          variant="red"
          className="font_m fw_5"
        >
          No Thanks, I want to move out.
        </TextButton>
      </div>
    </div>
  );
};
/* Component ends */

export default UnderReview;
